import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ColumnFieldTitle, OfbizAddDialogComponent, OfbizEditDialogComponent, OfbizField, OfbizForm, OfbizList, OfbizListComponent, RemoteFormData } from '@urbannex/ofbiz-forms';
import { NbDialogService, NbSidebarComponent, NbSidebarService } from '@nebular/theme';
import { LayoutService } from '../layout.service';
import { ActionState, ComponentConfig, ComponentState, OutGoingLink, SelectedValue } from '../shared/model';
import { Observable, Subject, Subscription } from 'rxjs';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { DialogContainerComponent } from '../dialog-container/dialog-container.component';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, ParamMap, Router, Event } from '@angular/router';
import { ViewContainersService } from '../shared/services/view-containers.service';


@Component({
  selector: 'ubs-list-container',
  templateUrl: './list-container.component.html',
  styleUrls: ['./list-container.component.scss'],
  // providers:[UbsComponentStoreService]
})
/** Acts as wrapper class for consuming list or table type components */
export class ListContainerComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  set state(state: Observable<ComponentState>) {
    state.subscribe(componentState => {
      this.state$ = componentState;
      this.title = "Listing " + componentState.workSpaceState;
      if (componentState.componentConfig != undefined) {
        this.componentConfig = componentState.componentConfig;
        if (componentState.componentConfig.listForm != undefined) {
          this.listForm = this.componentConfig.listForm;
          console.log({ ListForm: this.listForm })
          this.fieldOptions = this.listForm?.fieldFormFields;
          if (this.listForm.remoteFormData != undefined && this.listForm.remoteFormData != null) {
            this.remoteFormData = this.listForm.remoteFormData;
            console.log("Track RemoteFormData Change", this.listForm.remoteFormData);
          } else {
            this.remoteFormData = {
              formData: {
                formName: this.listForm?.listFormName,
                listType: this.listForm.listType,
                formLocation: this.listForm.listFormLocation,
                viewIndex: this.listForm.viewIndex,
              },
              endPoint: this.listForm.endPoint
            };
          }
          if (this.listForm?.findParameters) {
            console.log({ findParameters: this.listForm.findParameters });
            this.remoteFormData["parameters"] = {};
            this.listForm.findParameters.forEach(findParameter => {
              // console.log(findParameter);
              Object.keys(findParameter).forEach(key => {
                this.remoteFormData["parameters"][key] = findParameter[key];
                // this.remoteFormData["formData"][key] = findParameter[key];
              })
            });
          }
          if (this.listForm?.renderComponent) {
            this.hasRenderedComponent = true;
            this.renderComponent = this.listForm.renderComponent;
          }
          this.listOptions.formName = this.listForm?.listFormName;
          this.listOptions.entityName = this.listForm?.entityName;
          this.listOptions.formLocation = this.listForm?.listFormLocation;
          this.listOptions.viewIndex = this.listForm?.viewIndex;
          this.listOptions.endPoint = this.listForm?.endPoint;
          if (this.listForm?.columnFields) {
            this.columnFields = this.listForm.columnFields;
          }
          if (this.listForm.labelColumn) {
            this.listOptions.labelColumn = this.listForm.labelColumn;
          }
          if (this.listForm.listType) {
            this.remoteFormData.formData.listType = this.listForm.listType;
          }
          if (this.listForm.columnFieldTitles && this.listForm.columnFieldTitles != undefined) {
            this.columnFieldTitles = this.listForm.columnFieldTitles;
            console.log({ columnFieldTitles: this.columnFieldTitles })
          }
          if (this.listForm.idFieldName) {
            this.listOptions.idFieldName = this.listForm.idFieldName;
          }
          if (this.listForm.linkedList) {
            this.listOptions.linkedList = this.listForm.linkedList;
            this.hasLinkedList = true;
          }
        }
        if (componentState?.componentConfig.idFieldName) {
          this.listOptions.idFieldName = componentState.componentConfig.idFieldName;
        }
        if (componentState?.outGoingLink) {
          if (componentState.outGoingLink.parameters) {

            Object.keys(componentState.outGoingLink.parameters).forEach(key => {

            })
          }

        }

      }
      // console.log("FormName IN ListContainerComponent remoteFormData",this.remoteFormData.formData.formName)



      this.componentConfig = componentState.componentConfig;
    })
  }
  @Input() listForms: OfbizList[];
  @Input() addForms: OfbizForm[];
  state$: ComponentState;
  @Input() incomingLink: OutGoingLink;
  searchResultsSubscription: Subscription;
  selectedValueSubscription: Subscription;
  remoteFormData: RemoteFormData; // = {formData:null,endPoint:null};
  listForm: OfbizList;
  listType: string;
  fieldOptions: any = {};
  columnFields: any = {};
  columnFieldTitles: ColumnFieldTitle[];
  listOptions: any = {};
  findFields: OfbizField[]; // Fields to be used in list entity-display cells
  // settings:Settings = {};
  // ofbizForm = new OfbizForm;
  title: string;
  hasLinkedList = false;
  linkListActivate = false;
  isLookup = false;

  cardMode: boolean;

  // fields for linkedList

  linkedListOfbizForm: OfbizForm;
  linkedListListForm: OfbizList;
  result: any[];
  selectedValue: any;
  idField: string;
  idValue: string;

  // sideBarState
  sideBarState = "collapsed";
  hasSearchResults: boolean;
  hasRenderedComponent: boolean = false;
  renderComponent: any;

  componentConfig: ComponentConfig;
  private destroy$ = new Subject<void>();


  @ViewChild('listsideBar', { static: false }) sideNav: NbSidebarComponent;
  @ViewChild(OfbizListComponent) ofbizList !: any;
  /**
   *
   * @param componentStore
   * @param viewContainersService
   * @param sidebarService
   * @param layoutService
   * @param dialogService
   */
  constructor(private componentStore: UbsComponentStoreService,
    private viewContainersService: ViewContainersService,
    private sidebarService: NbSidebarService,
    private layoutService: LayoutService,
    private dialogService: NbDialogService,
    private router: Router
  ) { }

  fart(action: string) {
    console.log({ TrackRefresh: "fart" });
  }
  ngOnInit(): void {
    /* this.componentStore.outGoingLink$.subscribe((outGoingLink:OutGoingLink) => {
      console.log({OutGoingLink:outGoingLink,remoteFormData:this.remoteFormData});
    }) */
    this.searchResultsSubscription = this.viewContainersService.getHasSearchResults()
      .subscribe((data) => {
        if (data === true) {
          // console.log("There is fucking stuff");
          this.hasSearchResults = true;
          this.state.subscribe(data => {
            if (data.componentConfig.searchResults) {
              this.result = data.componentConfig.searchResults.list;
            }
          });
        }
      });

    this.selectedValueSubscription = this.viewContainersService.getListSelectedValue()
      .subscribe((selectedValue: SelectedValue) => {
        console.log({ "SelectedValueSubscription": selectedValue });
        if (selectedValue) {
          this.componentStore.updateSelectedValue(selectedValue);
          const event = selectedValue.event;
          switch (event) {
            case ActionState.VIEW:
              this.componentStore.updateAction(ActionState.VIEW);
              break;
            case ActionState.LIST:
              console.log({ parametersFromSelectedValue: selectedValue.data["parameters"] });
              this.remoteFormData.formData = selectedValue.data["formData"];
              this.remoteFormData["parameters"] = selectedValue.data["parameters"];
              this.componentStore.componentConfig$
                .subscribe((componentConfig: ComponentConfig) => {
                  console.log("ComponentConfing in handleHyperLinkSelected", componentConfig);
                  if (componentConfig != null) {
                    const formName = selectedValue.type;
                    this.setFieldsFromListForm(this.componentConfig, formName);
                    this.listForm = this.componentConfig.listForm;
                    this.cardMode = this.listForm.cardMode ? this.listForm.cardMode : false;
                    this.componentStore.updateAction(ActionState.LIST);
                  }

                })
              this.componentStore.updateAction(ActionState.LIST);
              break;
            case ActionState.ADD:
              console.log({ addingWhatWhat: event });
              break;
            default:
              break;
          }
        }

      })


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["hasSearchResults"]) {
      console.log(this.state);
    }
    if (changes["addForms"]) {
      console.log({ TrackAddForms: this.addForms })
      this.componentStore.activeLevel$.subscribe((data: number) => {
        this.listOptions.addForm = this.addForms[data - 1];
      })
    }
    if (changes["state"]) {
      console.log("The state has changed")
      // this.state.subscribe
      /* this.state.subscribe(data => {
        let listForm = data.componentConfig.listForm;
        console.log({NewListForm:listForm});
      }) */

      /* this.componentStore.outGoingLink$.subscribe((outGoingLink:OutGoingLink) => {
        console.log({OutGoingLink:outGoingLink,remoteFormData:this.remoteFormData});
      }) */
      /* this.state.subscribe((componentState:ComponentState) => {
        console.log({OutGoingLink:componentState.outGoingLink})
      })  */
      /* if(this.state$.outGoingLink){
        console.log({OutGoingLink:this.state$.outGoingLink.parameters,formName:this.listForm.listFormName,columnFields:this.listForm.columnFields})
      } */
    }
    if (changes["incomingLink"]) {
      console.log({ IncomingLink: this.incomingLink });
      if (this.incomingLink != null && this.incomingLink["parameters"]) {
        this.remoteFormData.parameters = this.incomingLink.parameters;
      }
    }
    if (changes["listForms"]) {
      console.log({ ListFormsChanges: this.listForm });
    }
  }


  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    this.sideNav?.stateChange.subscribe(
      data => {
        this.sideBarState = data;
      }
    )

    if (this.incomingLink) {
      console.log({ IncomingLink: this.incomingLink });
    }
  }


  toggleSideBar(): boolean {
    this.sidebarService.toggle(false, 'list-right');
    if (this.sideBarState == "expanded") {
      this.sidebarService.toggle(true, 'menu-sidebar');
    } else {
      this.sidebarService.expand('menu-sidebar');
    }
    this.layoutService.changeLayoutSize();

    return true;
  }

  // Only used with linkedLists
  loadCreate() {
    /* console.log(this.selectedValue);
    console.log(this.linkedListOfbizForm);
    console.log(this.listForm.linkedList["addFormOptions"]); */
    const options = this.listForm.linkedList["addFormOptions"];
    this.dialogService.open(OfbizAddDialogComponent, {
      context: {
        title: 'Add something',
        data: { "state": this.state, "options": options, "selectedValue": this.selectedValue }
      },
    });
  }

  showOverview(e) {
    // console.log("Overview selected in list-container");
    this.componentStore.updateSelectedValue(e);
    this.componentStore.updateAction(ActionState.VIEW);
  }

  showEditDialog(e) {
    const activeLevel: number = 1;
    e["componentConfig"] = this.componentConfig;
    this.componentStore.activeLevel$.subscribe((data: number) => {
      e["activeLevel"] = data;
      this.dialogService.open(DialogContainerComponent, {
        context: e
      }).onClose.subscribe(data => {
        if (data === "success") {
          this.ofbizList.refreshList()
          // this.componentStore.updateAction(ActionState.LIST);
        }
      });
    })

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.searchResultsSubscription.unsubscribe();

  }
  /**
   * Function to set the view type from a hyperlink clicked in a table to refresh the existing list
   * @param selectedValue of type SelectedValue consisting of the event,type and RemoteFormData
   */
  handleHyperLinkSelected(selectedValue: SelectedValue) {
    console.log({ TrackSelectedValue: "ListContainerComponent", value: selectedValue });
    console.log({ "TrackHyperLink": "handleHyperLinkSelected", "ListContainerComponentValue:": selectedValue });
    console.log("SelectedValue in handleHyperLinkSelected", selectedValue);
    // this.componentStore.updateSelectedValue(selectedValue);
    if (selectedValue.data.formData.link) {
      this.remoteFormData = selectedValue.data;
      /* this.remoteFormData = {
        formData:selectedValue.data["formData"],
        appContext:selectedValue.data["appContext"],
        parameters:selectedValue.data["parameters"]
      } */
      // this.componentStore.setState(null);

      console.log("Track RemoteFormData Change", this.remoteFormData);
      console.log(this.remoteFormData.formData["link"]);
      this.componentStore.updateSelectedValue(selectedValue);
      // this.router.navigateByUrl(selectedValue.data.formData.link);
      const link = selectedValue.data.formData.link;
      console.log(link)
      /**
       * Something's up here.  Why not navigate if master-detail
       * Temporarily adding an else that navigates anyway.
       * Fix this
       */
      if (selectedValue.event != "master-detail") {
        console.log("Navigating")
        this.router.navigateByUrl(link);
      } else {
        console.log("Navigating alt")
        this.router.navigateByUrl(link);
      }
    } else {
      const event = selectedValue.event;
      switch (event) {
        case ActionState.VIEW:
          this.componentStore.updateAction(ActionState.VIEW);
          break;
        case ActionState.LIST:
          const hyperlinkListForm = this.listForms.find(listForm => listForm.listFormName == selectedValue.data.formData.formName);
          if (hyperlinkListForm != undefined) {
            this.listForm = hyperlinkListForm;
            if (this.listForm.cardMode != undefined) {
              this.cardMode = this.listForm.cardMode;
            }
          }
          console.log({ HyperlinkListForm: hyperlinkListForm, cardMode: this.cardMode });
          this.setActiveLevel(selectedValue.data.formData.formName, this.listForms);
          this.remoteFormData = {
            formData: selectedValue.data["formData"],
            appContext: selectedValue.data["appContext"],
            parameters: selectedValue.data["parameters"]
          }
          console.log({ RemoteFormDataHandleHyperLink: this.remoteFormData });
          this.componentStore.componentConfig$
            .subscribe((componentConfig: ComponentConfig) => {
              if (componentConfig != null) {

                this.setFieldsFromListForm(this.componentConfig, selectedValue.type);
                this.componentStore.updateAction(ActionState.LIST);

              }


            });
          break;
        case ActionState.DELETE:
          console.log({ deleteState: event });
          this.remoteFormData.formData = selectedValue.data["formData"];
          this.remoteFormData["parameters"] = selectedValue.data["parameters"];
          break;
        case ActionState.EDIT:
          console.log({ "TrackEdit": event, "component": "ListContainerComponent" });
          this.componentStore.updateAction(ActionState.EDIT);
          break;
        case ActionState.ADD:

          this.componentStore.selectedValue$.subscribe((data) => { console.log("SelectedValue in Add", data); })
          this.remoteFormData.formData = selectedValue.data["formData"];
          this.remoteFormData["parameters"] = selectedValue.data["parameters"];
          console.log({ remoteFormData: this.remoteFormData });
          this.componentStore.updateAction(ActionState.ADD);
          break;
        case ActionState.LINK:
          console.log({ "linkingThings": event, "component": "ListContainerComponent" });
          this.componentStore.outGoingLink$.subscribe(data => {
            console.log({ OutGoingLink: data });
          })
          break;
        default:
          break;
      }
      this.componentStore.updateSelectedValue(selectedValue);
    }



  }
  /**
   * Function gets data from list and notifies header via ViewContainersService
   * Data is only sent if getList return a list successfully
   * Data is used in breadCrumb creation
   * @param data : RemoteFormData
   */
  handleListSucessNotify(data: any): void {
    console.log("successData in ListContainerComponent", data);
    this.viewContainersService.setNotifiedSuccess(data);
    // this.componentStore.selectedValue$.subscribe(data => console.log("selectedValue in ListContainerComponent",data))
  }
  /**
   * Function sets columnFields to be used in tables and findFields to be used for display-entities
   * @param componentConfig
   * @param formName
   */
  setFieldsFromListForm(componentConfig: ComponentConfig, formName: string): void {
    console.log("formName in ListContainerComponent", formName);
    console.log("ComponentConf in setFieldsFromListForm", componentConfig);
    const listForm = componentConfig.listForm;
    if (listForm.listFormName == formName) {
      this.columnFields = listForm.columnFields;
      this.fieldOptions = listForm.fieldFormFields;
      if (listForm.idFieldName) {
        this.listOptions["idFieldName"] = listForm.idFieldName;
        console.log({ "ListOptions": this.listOptions });
      }
      if (listForm.target) {
        this.listOptions.target = listForm.target;
      }
      console.log("FieldOptions in ListContainerComponent", this.fieldOptions);
    } else if (componentConfig.childComponent && componentConfig.childComponent.listForm.listFormName == formName) {
      const listForm = componentConfig.childComponent.listForm;
      this.columnFields = listForm.columnFields;
      this.fieldOptions = listForm.fieldFormFields;
      if (listForm.idFieldName) {
        this.listOptions["idFieldName"] = listForm.idFieldName;
        console.log({ "ListOptions": this.listOptions });
      }
      if (listForm.target) {
        this.listOptions.target = listForm.target;
      }
      /* console.log("ListForm",componentConfig.childComponent.listForm)
      console.log("columnFields",this.columnFields);
      console.log("FieldOptions in ListContainerComponent",this.fieldOptions);
      console.log("FieldOptions in ListContainerComponent",this.fieldOptions); */
    } else if (componentConfig.childComponent.childComponent && componentConfig.childComponent.childComponent.listForm.listFormName == formName) {
      const listForm = componentConfig.childComponent.childComponent.listForm;
      this.columnFields = componentConfig.childComponent.childComponent.listForm.columnFields;
      this.fieldOptions = componentConfig.childComponent.childComponent.listForm.fieldFormFields;
      if (listForm.idFieldName) {
        this.listOptions["idFieldName"] = listForm.idFieldName;
        console.log({ "ListOptions": this.listOptions });
      }
      if (listForm.target) {
        this.listOptions.target = listForm.target;
      }
    }
  }

  setActiveLevel(formName: string, listForms: any[]) {
    console.log({ formNameSetActiveLevel: formName, listForms: listForms })
    let activeLevel: number = listForms.findIndex(listForm => listForm.listFormName == formName);
    console.log({ TrackActiveLevelBefore: "ListContainerComponent", value: activeLevel });
    activeLevel = activeLevel + 1;
    console.log({ TrackActiveLevelAfter: "ListContainerComponent", value: activeLevel });
    // this.componentStore.updateActiveLevel(activeLevel)
    /* let nextActiveLevel:number;
    this.componentStore.activeLevel$
    .subscribe(data => {
      let currentActiveLevel = data;
      nextActiveLevel = currentActiveLevel+1

    });
*/
    this.componentStore.setActiveLevel(activeLevel);
    // return activeLevel;
  }
  onUserRowSelect(e) {
    console.log(e);
  }
}
